const requirements = {
    name: 'Requirements',
    path: '/requirements',
    icon: 'mdi-file-sign',
    label: 'Requirements',
};

const horizon = {
    name: 'Horizon',
    path: '/horizon',
    icon: 'mdi-sun-angle',
    label: 'Horizon',
    private: true,
    privateLabel: 'SA'
};

const pulse = {
    name: 'Pulse',
    path: '/pulse',
    icon: 'mdi-pulse',
    label: 'Pulse',
    private: true,
    privateLabel: 'SA'
};

const telescope = {
    name: 'Telescope',
    path: '/telescope',
    icon: 'mdi-telescope',
    label: 'Telescope',
    private: true,
    privateLabel: 'SA'
};

const staff = {
    name: 'Staff',
    path: '/staff',
    icon: 'mdi-account-group',
    label: 'Staff'
};

const programs = {
    name: 'Programs',
    path: '/programs',
    icon: 'mdi-home',
    label: 'Programs'
};

const clients = {
    name: 'Clients',
    path: '/clients',
    icon: 'mdi-account-supervisor',
    label: 'Clients'
};

const templates = {
    name: 'Templates',
    path: '/templates',
    icon: 'mdi-file-document',
    label: 'Templates'
};

export const superAdmin = _ => {
    return [
        staff,
        programs,
        clients,
        requirements,
        templates
    ];
};

export const programCoordinator = _ => {
    return [
        staff,
        programs,
        clients,
        templates
    ];
};

export const programSupervisor = _ => {
    return [
        staff
    ];
};

export const clientSupportWorker = _ => {
    return [
        programs,
        clients,
    ];
};

export const programDirector = _ => {
    return [
        staff,
        programs,
        clients,
        templates
    ];
};

export const organizationAdmin = _ => {
    return [
        staff,
        programs,
        clients,
        requirements,
        templates
    ];
};

export const bottomNavRoutes = _ => {
    return [
        horizon,
        pulse,
        telescope,
    ];
};
